import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import { Navbar } from "react-bootstrap";
import logo from "../images/pal-logo.jpg";
import { Link } from "react-router-dom";
import "./MyNavbar.css";
import { useLanguage } from '../context/LanguageContext';
import LanguageSwitcher from "./LanguageSwitcher";

function CollapsibleExample() {
  const { language } = useLanguage();

  return (
    <div className="div-nav">
      {/* <LanguageSwitcher /> */}

      <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary">
        <Container>
          <Link as={Link} to="/">
            <img
              style={{ width: 80, height: 80, borderRadius: 50 }}
              src={logo}
              alt="Company Logo"
              className="logo-img"
            />
          </Link>
          {/*<Navbar.Brand Link as={Link} to="/"><h4>Palliative Care Manjeri</h4></Navbar.Brand>*/}
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <NavDropdown title="Who we are" id="collapsible-nav-dropdown">
                <NavDropdown.Item as={Link} to="/aboutus">
                  About Us
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/historypage">
                  History
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown
                title="Academics & Researches"
                id="collapsible-nav-dropdown"
              >
                <NavDropdown.Item as={Link} to="/tabspage">
                  CDPC
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/research">
                  Study & Research
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Services" id="collapsible-nav-dropdown">
                <NavDropdown.Item as={Link} to="/centerspage">
                  Coordination
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/services">
                  Patient Care
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Resources" id="collapsible-nav-dropdown">
                <NavDropdown.Item as={Link} to="/newsletter">
                  News Letter
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/articles">
                  Articles
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/bookspage">
                  Books
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/videogallery">
                  Videos
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/imagegallery">
                  Gallery
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Join with us" id="collapsible-nav-dropdown">
                <NavDropdown.Item as={Link} to="/volunteerform">
                  As Volunteer
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/donationpage">
                  Donate
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link as={Link} to="/careers">
                Careers
              </Nav.Link>

              <Nav.Link as={Link} to="/contactus">
                Contact Us
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}

export default CollapsibleExample;
